/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Feedback_Remove_TooltipInputs */



/**
* | output |
* | --- |
* | "Remove feedback" |
*
* @param {Chat_Feedback_Remove_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_feedback_remove_tooltip = /** @type {((inputs?: Chat_Feedback_Remove_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Feedback_Remove_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bewertung entfernen")
	return /** @type {LocalizedString} */ ("Remove feedback")
});